/** Venues (docs/API.md "Venues"): the catalog and the waitlist of venues that are not live yet. */
import { z } from 'zod'
import { VenueListing, VenueParams, VenueWaitlistLeft, VenueWaitlistResult } from '../venues.js'
import { defineRoute, type RouteDef } from './define.js'

export const venueRoutes = {
  listVenues: defineRoute({
    method: 'GET',
    path: '/venues',
    auth: 'public',
    summary: 'Venue catalog (live and coming soon) with public waitlist counts, and the caller’s waitlist state when signed in',
    response: z.array(VenueListing),
  }),
  joinVenueWaitlist: defineRoute({
    method: 'POST',
    path: '/venues/:id/waitlist',
    auth: 'session',
    summary: 'Join the waitlist of a coming-soon venue (idempotent per user)',
    params: VenueParams,
    response: VenueWaitlistResult,
  }),
  leaveVenueWaitlist: defineRoute({
    method: 'DELETE',
    path: '/venues/:id/waitlist',
    auth: 'session',
    summary: 'Leave the waitlist of a coming-soon venue (idempotent; only the caller’s own sign-up)',
    params: VenueParams,
    response: VenueWaitlistLeft,
  }),
} as const satisfies Record<string, RouteDef>
